import { appStore } from 'src/stores'
import { $api } from 'src/plugins'
import { write } from 'xlsx'
import { postMsg } from '../root/helper'
import { initFilter } from 'src/utils/common'

export const getTemplateConfig = (formCode: string) => {
  const { OrgId } = appStore.current.headers
  const payload = initFilter({ OrgId, Keyword: formCode })

  return $api['app/getImportConfig'](payload)
}

export const downloadTemplate = (tempConfig: any) => {
  // 字符串转字符流
  const s2ab = (s: string) => {
    const buf = new ArrayBuffer(s.length)
    const view = new Uint8Array(buf)
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xFF
    }
    return buf
  }

  const getCharCol = (n: number) => {
    let s = '', m = 0
    while (n > 0) {
      m = n % 26 + 1
      s = String.fromCharCode(m + 64) + s
      n = (n - m) / 26
    }
    return s
  }

  const convertData = (json: any[]) => {
    // 获取键
    const keyMap = Object.keys(json[0])
    // 用来保存转换好的json
    const tmpdata: any[] = []
    json.map((v, i) => {
      return keyMap.map((k, j) => ({
        v: v[k],
        position: (j > 25 ? getCharCol(j) : String.fromCharCode(65 + j)) + (i + 1)
      }))
    }).reduce((prev, next) => {
      return prev.concat(next)
    }).forEach((v: any) => {
      tmpdata[v.position] = { v: v.v }
    })
    return tmpdata
  }

  $api['app/getDataByPost'](tempConfig, {
    url: `/${tempConfig.SERVICE_CODE ?? 'PF'}/Import/DownLoadFile`
  }).then((res: any) => {
    if (!res) {
      postMsg('没有模板文件', 'error')
      return
    }
    const tmpWB: any = {
      SheetNames: [], // 保存的表标题
      Sheets: {}
    }
    const { Name, ImportTable = [], ImprotTableModel = {} } = res
    ImportTable.forEach((item: any) => {
      const { Nav_Fields, DESCRIPTION, Data = [] } = item
      tmpWB.SheetNames.push(DESCRIPTION)

      const exportData = []
      if (Nav_Fields) {
        const head: any = {}
        Nav_Fields.forEach((field: any) => {
          field.DEST_FIELD_NAME && (head[field.DEST_FIELD_NAME] = field.SRC_FIELD_NAME)
        })
        exportData.push(head)
        Data.forEach((data: any) => {
          const row: any = {}
          Nav_Fields.forEach((field: any) => {
            let tmp = data
            let dex = field.DEST_FIELD_NAME
            if (dex.indexOf('.') > 0) {
              let tmpIndex = dex.indexOf('.')
              while (tmpIndex > 0 && tmp) {
                tmp = tmp[dex.substring(0, tmpIndex)]
                dex = dex.substring(tmpIndex + 1)
                tmpIndex = dex.indexOf('.')
              }
            }
            if (tmp) {
              let value = tmp[dex]
              if (field.ENUM) {
                const { Nav_Enums = [] } = ImprotTableModel
                const find = Nav_Enums.find((item: any) => item.EnumName === field.ENUM)?.options.find((item: any) => item.value === value)
                find?.label && (value = find.label)
              }
              row[field.DEST_FIELD_NAME] = value
            }
          })
          exportData.push(row)
        })
        const lastData = convertData(exportData)
        // 设置区域,比如表格从 A1 到 D10
        const outputPos = Object.keys(lastData)
        tmpWB.Sheets[String(DESCRIPTION)] = Object.assign({}, lastData, {
          '!ref': outputPos[0] + ':' + outputPos[outputPos.length - 1] // 设置填充区域
        })
      }
    })
    const tmpDown = new Blob(
      [
        // 定义导出的格式类型
        s2ab(write(tmpWB, {
          bookType: 'xlsx',
          bookSST: false,
          type: 'binary',
          cellStyles: true
        }))
      ],
      { type: 'string' }
    )
    postMsg('成功获取数据')
    // 下载
    const url = URL.createObjectURL(tmpDown)
    const anchor = document.createElement('a')
    anchor.href = url
    anchor.download = `${Name}.xlsx`
    anchor.click()
    URL.revokeObjectURL(url)
  })
}